import { Workflow, Zap, ShieldCheck } from "lucide-react";
import { HOME } from "@/constants/testIds";

const items = [
  {
    icon: Workflow,
    title: "One platform. More focus.",
    body: "1 connected workspace. 12 business modules. 4 AI specialists. 15 separate tools.",
    emphasis: "No more juggling.",
  },
  {
    icon: Zap,
    title: "Plans start at €499/month",
    body: "Replace around €1,190 per month in separate professional software with one connected platform.",
    emphasis: "Save around €691 every month.",
  },
  {
    icon: ShieldCheck,
    title: "Your data. Your control.",
    body: "Zynthoro is EU-hosted and GDPR-ready, with audit trails and role-based access built in from day 1.",
    emphasis: "Compliance is part of the platform, not an add-on.",
  },
];

export default function WhyZynthoro() {
  return (
    <section id="why" data-testid={HOME.why} className="zy-section bg-white">
      <div className="zy-container">
        <div className="max-w-3xl mx-auto text-center mb-16 zy-reveal">
          <p className="zy-eyebrow mb-4">Why Zynthoro</p>
          <h2 className="zy-h2">Your business works better when everything flows together.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {items.map(({ icon: Icon, title, body, emphasis }, i) => (
            <div
              key={title}
              className="zy-reveal"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="zy-domain-icon" style={{ width: 52, height: 52 }}>
                <Icon size={22} />
              </div>
              <h3 className="zy-h3 mt-1 mb-3">{title}</h3>
              <p className="zy-body" style={{ fontSize: "1rem" }}>{body}</p>
              <p className="mt-3 font-bold text-[#0A1628]">{emphasis}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
